import {
  emptyProcedureWorksheet,
  type MskRegion,
  type MskWorksheetData,
  type ProcedureWorksheetData,
} from "$global-providers/rxdb-provider/collections/epocus-exam-worksheets";
import { mskRegionData } from "../msk-regions";
import { GUIDED_JOINT_INJECTION } from "./guided-joint-injection";

const JOINT_SITE_BY_MSK_REGION: Partial<Record<MskRegion, string>> = {
  knee: "knee",
  ankle: "ankle",
  wristHand: "wrist",
};

export const mskToGuidedJointInjection = (
  msk: MskWorksheetData,
  region: MskRegion,
): ProcedureWorksheetData => {
  const { side } = mskRegionData(msk, region);
  const site = JOINT_SITE_BY_MSK_REGION[region];
  return {
    ...emptyProcedureWorksheet(GUIDED_JOINT_INJECTION.examType),
    definitionVersion: GUIDED_JOINT_INJECTION.version,
    findings: {
      ...(side ? { side } : {}),
      ...(site ? { site } : {}),
    },
    notes: msk.notes,
  };
};
